const LangHeader = {
	"header.topMenu._about_acsw": ["About ACSW", "About ACSW VN"],
	"header.topMenu._redemption_items": ["Redemption Items", "Redemption Items VN"],
	"header.topMenu._t&cs": ["T&Cs", "T&Cs VN"],
	"header.topMenu._login_signup": ["Sign In / Sign Up", "Đăng nhập / Đăng ký"],
}

export default LangHeader



// WEBPACK FOOTER //
// ./src/resources/modules/LangHeader.js